// extracted by mini-css-extract-plugin
export default {"thankyou":"Thankyou_thankyou__IsjsY","thankyou1":"Thankyou_thankyou1__4QRtJ","thankyou123":"Thankyou_thankyou123__W6DZa"};